<template>
  <div class="real-box">
    <h6 class="seccion-titulo text-success">
      <font-awesome-icon icon="clipboard-check" class="me-1" />
      Ejecución Real
    </h6>

    <template v-if="actividad.tareas.length">
      <p>
        <strong>Total Gastado:</strong> {{ simbolo }}{{ formatoCostoTotal }}
      </p>

      <p>
        <strong>Cantidad de tareas ejecutadas:</strong> {{ actividad.tareas.length }}
      </p>

      <div v-if="tareasCoincidentes.length" class="mt-3 small">
        <strong>Coincidencias con el plan:</strong>
        <ul class="mb-0 mt-1 ps-3">
          <li v-for="t in tareasCoincidentes" :key="t.id">
            <a href="#" @click.prevent="$emit('ver', t)">
              {{ t.nombre_tarea.nombre }}
            </a>
          </li>
        </ul>
      </div>

      <div v-if="actividad.inconsistente" class="alert alert-warning mt-3 p-2 small">
        ⚠️ Algunas tareas ejecutadas tienen nombres distintos al plan:
        <ul class="mb-0 mt-1 ps-3">
          <li v-for="nombre in actividad.nombres_reales_diferentes" :key="nombre">
            {{ nombre }}
          </li>
        </ul>
      </div>
    </template>

    <template v-else>
      <p class="text-muted fst-italic">No se registraron ejecuciones reales.</p>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    actividad: Object,
    simbolo: String
  },
  computed: {
    tareasCoincidentes() {
      return this.actividad.tareas.filter(
        t => t.nombre_tarea?.nombre === this.actividad.nombre_tarea
      );
    },
    formatoCostoTotal() {
      const costo = this.actividad.total_costo_final;
      return typeof costo === 'number' ? costo.toFixed(2) : '0.00';
    }
  }
};
</script>

<style scoped>
.real-box {
  background-color: #eafaf1;
  border-left: 5px solid #28a745;
  padding: 1rem;
  border-radius: 6px;
  font-size: 0.9rem;
}
.seccion-titulo {
  font-weight: 600;
  font-size: 1rem;
}
</style>
